import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import Dashboard from "./Dashboard/Dashboard";
import { UseRoleContext } from "../../../utils/RoleContext";
import { Box, CircularProgress } from "@mui/material";

const AdminLayout = () => {
  const nav = useNavigate();
  const context = UseRoleContext()
  useEffect(() => {
    if (context.basicUserInfo) {

    } else {
      nav("/login")
    }
  }, [context.basicUserInfo])
  if(context.isLoading) {
    return(<Box sx={{display : 'flex'}}>
        <CircularProgress />
    </Box>)
  }
  if ((context.IsAdminRh || context.isDevRh || context.isAssistantRh || context.isManager)) {
    return <Dashboard />;
  }
  if(context === undefined) {
    return null
  }
  return <Navigate to="/login" />
};

export default AdminLayout;
